import { useCallback } from 'react';
import { useLanguageContext } from './useContext/useLanguageContext';
import translations from '../language';

const normalizeText = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

const translationKeyLookup = Object.entries(translations).reduce((lookup, [key, value]) => {
  const normalizedKey = normalizeText(key);
  if (normalizedKey) {
    lookup[normalizedKey] = key;
  }

  if (value && typeof value === 'object') {
    const enValue = value.en;
    const plValue = value.pl;

    const normalizedEn = normalizeText(enValue);
    const normalizedPl = normalizeText(plValue);

    if (normalizedEn && !lookup[normalizedEn]) {
      lookup[normalizedEn] = key;
    }
    if (normalizedPl && !lookup[normalizedPl]) {
      lookup[normalizedPl] = key;
    }
  }

  return lookup;
}, {});

export const useTranslation = () => {
  const { language } = useLanguageContext();
  
  const t = useCallback(
    (key) => {
      const lang = language || 'en';
      const rawKey = String(key || '');

      const directTranslation = translations[rawKey]?.[lang];
      if (directTranslation) {
        return directTranslation;
      }

      const normalized = normalizeText(rawKey);
      const resolvedKey = translationKeyLookup[normalized];
      if (resolvedKey && translations[resolvedKey]?.[lang]) {
        return translations[resolvedKey][lang];
      }

      return rawKey;
    },
    [language]
  );

  return { t, language };
};
